import { render, staticRenderFns } from "./PendingConsentNotification.vue?vue&type=template&id=4ca2f6ee"
import script from "./PendingConsentNotification.vue?vue&type=script&lang=js"
export * from "./PendingConsentNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports